import { Text } from "@chakra-ui/react"
import { useBrandedTranslation } from "../../../../../common/hooks/useBrandedTranslation"

type Props = {
  languages: string[]
  currentLanguage: string
}

const DocumentLanguages = ({ languages, currentLanguage }: Props) => {
  const { t } = useBrandedTranslation()

  return (
    <>
      {languages.length > 1 ? (
        <Text>{`${currentLanguage} ${t("documents-and-more", { n: languages.length - 1 })}`}</Text>
      ) : languages.length === 0 ? (
        <Text>-</Text>
      ) : (
        <Text>{languages[0]}</Text>
      )}
    </>
  )
}

export default DocumentLanguages
